module.exports = __webpack_public_path__ + "static/img/aimeikongjian.f27ad51.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/aimeikongjian.png
// module id = It2P
// module chunks = 1